module.exports = __webpack_public_path__ + "img/29.6fb0ae19.jpeg";